import { enqueueSnackbar } from 'actions';

import {
	GetSitesRequest,
	GetSiteDetailsRequest,
	EditValueRequest,
	RunAlgoPlanRequest,
	CreateScriptsRequest
} from '../requests/PlanningRequests.js';

export const GET_SITES = 'GET_SITES';
export const SET_SELECTED = 'SET_SELECTED';
export const GET_SITE = 'GET_SITE';
export const EDIT_ROW_VALUE = 'EDIT_ROW_VALUE';
export const UPDATE_SELECTED_ROWS = 'UPDATE_SELECTED_ROWS';

const onGetSites = (value) => ({
	type: GET_SITES,
	sites: value
});

const onSetSelected = (value) => ({
	type: SET_SELECTED,
	selected: value
});

const onGetSite = (value) => ({
	type: GET_SITE,
	site: value
});

const onUpdateSelectedRows = (selectedRows, tech) => ({
	type: UPDATE_SELECTED_ROWS,
	selectedRows,
	tech
});

export const GetSites = () => async (dispatch) => {
	await GetSitesRequest().then(response => {
		dispatch(onGetSites(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SetSelected = (selected) => async (dispatch) => {
	dispatch(onSetSelected(selected));
};

export const GetSite = (selected) => async (dispatch) => {
	await GetSiteDetailsRequest(selected).then(response => {
		dispatch(onGetSite(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditValue = (data, tech) => async (dispatch) => {
	await EditValueRequest(data, tech).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunAlgoPlan = (site) => async (dispatch) => {
	await RunAlgoPlanRequest(site).then(response => {
		dispatch(enqueueSnackbar({ message: 'Planning finished.', options: { variant: 'success' } }));
		dispatch(GetSite(site));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateScripts = (selectedRows, operation, userId) => async (dispatch) => {
	const cells = [];
	Object.keys(selectedRows).forEach(tech => {
		selectedRows[tech].forEach(row => {
			cells.push(row.name);
		});
	});
	await CreateScriptsRequest(cells, operation, userId).then(response => {
		dispatch(enqueueSnackbar({ message: 'Running scripts.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UpdateSelectedRows = (selectedRows, tech) => dispatch => {
	dispatch(onUpdateSelectedRows(selectedRows, tech));
};
